export default __webpack_public_path__ + "static/media/box1.8a39bde9.svg";